import { cva } from 'class-variance-authority';

/**
 * The base surface: neutral background, rounded corners, and a solid border.
 * Shared by Surface, Card, and Box so the base surface is declared once.
 */
export const SURFACE_BASE =
  'bg-neutral border border-solid border-neutral-border rounded-xl';

export const surfaceVariants = cva(SURFACE_BASE, {
  variants: {
    padding: {
      none: '',
      sm: 'p-4',
      md: 'p-5',
      lg: 'p-6',
    },
    shadow: {
      none: '',
      sm: 'shadow-sm',
      md: 'shadow',
    },
  },
  defaultVariants: {
    padding: 'none',
    shadow: 'none',
  },
});
